import React from "react";
import { Landmark, Play, Quote } from "lucide-react";

const VIDEO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_acdt-hub/artifacts/fnqehl25_testimonianza%20nel%20mondo%20digitale%20alla%20camera%20dei%20deputati.mp4";

/**
 * Sezione home: testimonianza sull'importanza del digitale portata alla Camera dei Deputati.
 * Visibile a tutti i visitatori del sito.
 */
export default function TestimonianzaCameraHome() {
  return (
    <section
      id="camera-deputati"
      className="relative py-16 md:py-24 bg-gradient-to-b from-slate-50 via-white to-slate-50"
      data-testid="testimonianza-camera-home"
    >
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="reveal max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#c8102e]/10 text-[#c8102e] text-[10.5px] font-extrabold uppercase tracking-[0.22em]">
            <Landmark className="h-3.5 w-3.5" />
            Roma · Camera dei Deputati
          </div>
          <h2 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0a1f55] leading-tight">
            Il digitale alla <span className="text-[#f59e0b]">Camera dei Deputati</span>
          </h2>
          <p className="mt-4 text-[15px] md:text-[16px] text-slate-600 leading-relaxed">
            Una <strong>testimonianza sull&apos;importanza del mondo digitale</strong> portata nelle aule
            istituzionali della Camera dei Deputati. Il digitale come infrastruttura che riguarda tutti:{" "}
            <strong>privati, professionisti e istituzioni</strong>.
          </p>
        </div>

        <div className="mt-10 grid lg:grid-cols-[1.4fr_1fr] gap-6 items-start">
          {/* Video */}
          <div className="reveal rounded-3xl overflow-hidden shadow-[0_20px_60px_-20px_rgba(10,31,85,0.4)] border-2 border-[#0a1f55]/10 bg-white">
            <div className="relative bg-black aspect-video">
              <video
                controls
                preload="metadata"
                className="w-full h-full object-contain"
                poster="https://customer-assets.emergentagent.com/job_b32a9d06-cd1a-4936-8a74-34f0d65c7ad3/artifacts/t9kdcc0c_ACDT_logo_800x520.jpg"
                data-testid="home-testimonianza-video"
              >
                <source src={VIDEO_URL} type="video/mp4" />
                Il tuo browser non supporta il tag video.
              </video>
            </div>
            <div className="p-5 md:p-6">
              <div className="inline-flex items-center gap-1.5 text-[11px] font-bold text-slate-500 uppercase tracking-wider">
                <Play className="h-3 w-3" />
                Guarda l&apos;intervento integrale
              </div>
              <h3 className="mt-1 font-extrabold text-[#0a1f55] text-[17px] md:text-[18px]">
                Digitale come diritto: privati, professioni e istituzioni
              </h3>
            </div>
          </div>

          {/* Highlights */}
          <aside
            className="reveal rounded-3xl border border-slate-200 bg-white p-6 md:p-7 shadow-sm"
            data-testid="home-testimonianza-highlights"
          >
            <div className="flex items-center gap-2 mb-4">
              <div className="h-10 w-10 rounded-lg bg-[#0a1f55] text-[#f59e0b] flex items-center justify-center">
                <Quote className="h-5 w-5" />
              </div>
              <div>
                <div className="text-[10.5px] font-extrabold uppercase tracking-[0.18em] text-[#f59e0b]">
                  Highlights
                </div>
                <h3 className="font-extrabold text-[#0a1f55] text-[16px] leading-tight">
                  I passaggi chiave
                </h3>
              </div>
            </div>
            <ol className="space-y-3">
              <Item
                tempo="00:20"
                testo="Il digitale non è più un&apos;opzione: è infrastruttura di cittadinanza. Chi resta indietro perde diritti concreti."
              />
              <Item
                tempo="01:10"
                testo="Serve una figura professionale che faccia da ponte tra tecnologia, persone, imprese e Pubblica Amministrazione."
              />
              <Item
                tempo="02:15"
                testo="La formazione certificata e riconosciuta è la chiave per qualificare consulenti digitali competenti e affidabili."
              />
              <Item
                tempo="03:00"
                testo="Il ruolo delle istituzioni: cornici normative chiare e valorizzazione delle competenze digitali emergenti."
              />
              <Item
                tempo="04:20"
                testo="Sostenibilità e digitale insieme: tutela dei dati, uso consapevole della tecnologia, formazione continua."
              />
              <Item
                tempo="05:30"
                testo="Appello a Parlamento e associazioni: fare rete e riconoscere il valore del Consulente Digitale come alleato del Paese."
              />
            </ol>
          </aside>
        </div>
      </div>
    </section>
  );
}

function Item({ tempo, testo }) {
  return (
    <li className="flex gap-3">
      <div className="shrink-0 h-6 min-w-[52px] rounded-md bg-[#0a1f55] text-white text-[10.5px] font-mono font-bold flex items-center justify-center">
        {tempo}
      </div>
      <p
        className="text-[13px] text-slate-700 leading-relaxed"
        dangerouslySetInnerHTML={{ __html: testo }}
      />
    </li>
  );
}
